import { Injectable} from 'ng-metadata/core';
import {getPrimoShortDateFormat, getIlsDateFormat, getPrimoLongDateFormat} from '../appConfig/appConfigForward';

const dayjs= require('dayjs');
const customParseFormat = require('dayjs/plugin/customParseFormat');
dayjs.extend(customParseFormat);
@Injectable()
export class DateUtils {
    private _ilsDateFormat: string;
    private _primoShortDateFormat: string;
    private _primoLongDateFormat: string;

    constructor(){
        this._ilsDateFormat= getIlsDateFormat();
        this._primoShortDateFormat= getPrimoShortDateFormat();
        this._primoLongDateFormat= getPrimoLongDateFormat();
    }

    get primoShortDateFormat(){
        return this._primoShortDateFormat;
    }

    get primoLongDateFormat(){
        return this._primoLongDateFormat;
    }

    get ilsDateFormat(){
        return this._ilsDateFormat;
    }

    convertDateStringToDateType(dateString:string, dateStringFormat: string){

        if (!dateString || !dateStringFormat) {
            return;
        }

        let format = 'MMM DD, YYYY hh:mm:ss A';
        let parsed = dayjs(dateString, format, true);
        if (!parsed.isValid() && /\s(1[3-9]|2[0-3]):\d{2}:\d{2}\s+PM$/i.test(dateString)) {
            // Server may emit a 24-hour hour with a stray PM marker (e.g. '13:08:45 PM'), in this case drop the pm
            parsed = dayjs(dateString.replace(/\s+PM$/i, ''), 'MMM DD, YYYY HH:mm:ss', true);
        }
        if (parsed.isValid()) {
            return parsed.toDate();
        }

        let year:number = 0,
            month:number = 0,
            day:number = 0,
            hour:number = 0,
            minutes:number = 0,
            seconds:number = 0;


        for(let i=0; i< dateString.length ; i++){
            let c = dateString[i];
            switch(dateStringFormat[i]){
                case 'y': year = year*10 + parseInt(c); break;
                case 'M': month = parseInt(c) >= 0 ? month*10 + parseInt(c) : this.extractMonth3Letters(dateString,dateStringFormat,dateString.substring(i,i+3)); if(this.isthreeLetterMonth(dateStringFormat)){i+=2;};  break;
                case 'd': day = day*10 + parseInt(c); break;
                case 'h': hour = hour*10 + parseInt(c); break;
                case 'm': minutes = minutes*10 + parseInt(c); break;
                case 's': seconds = seconds*10 + parseInt(c); break;

                default: break;
            }
        }
        return new Date(year,month - 1 /* January start from 0 */,day,hour,minutes,seconds,0);
    }

    extractMonth3Letters(dateString,dateStringFormat,month){
        if(this.isthreeLetterMonth(dateStringFormat)){
            return this.letterMonthToNumber(month);
        }
        return 1;//default

    }

    isthreeLetterMonth(dateStringFormat){
        return dateStringFormat.indexOf('-MMM-') > -1;
    }
    letterMonthToNumber(monthIn3Letters){
        let monthMap = {
            'jan':1,
            'feb': 2,
            'mar': 3,
            'apr': 4,
            'may': 5,
            'jun': 6,
            'jul': 7,
            'aug': 8,
            'sep': 9,
            'oct': 10,
            'nov': 11,
            'dec': 12

        };
        return monthMap[monthIn3Letters.toLowerCase()] || 1;

    }

    /**
     * Convert formated date (string | Date) to different format
     * @param date e.g. 20151214
     * @param currentFormat e.g. yyyyMMdd
     * @param newFormat e.g. dd/MM/yyyy
     * @returns {string} e.g. 14/12/2015
     */
    fromString(date: string | Date, currentFormat: string, newFormat: string) {
        return typeof date === 'string' || date === undefined ?
            dayjs(date, currentFormat).format(newFormat) : dayjs(date).format(newFormat)
    }

    convertIlsDateStringToPrimoDateString(ilsDate: string){
        return this.fromString(ilsDate, this._ilsDateFormat.toUpperCase(), this._primoShortDateFormat.toUpperCase());

    }

    convertPrimoDateStringToIlsDateString(primoDate: string){
        return this.fromString(primoDate, this._primoShortDateFormat.toUpperCase(), this._ilsDateFormat.toUpperCase());
    }

    public convertDateTypeToIlsDateString(date: Date){
        if (date) {
            return dayjs(date).format(this._ilsDateFormat.toUpperCase());
        }
    }

    public convertDateTypeToFormatString(date: Date, formatString: string){
        if(date){
            return dayjs(date).format(formatString.toUpperCase());
        }
        else {
            return '';
        }
    }

    public convertDateTypeToPrimoDateString(date: Date){
        if (date) {
            return dayjs(date).format(this._primoShortDateFormat.toUpperCase());
        }
    }


    public convertIlsDateStringToDateType(IlsDateString){
        return this.convertDateStringToDateType(IlsDateString, this._ilsDateFormat);
    }

    public convertPrimoDateStringToDateType(dateString){
        return this.convertDateStringToDateType(dateString, this._primoShortDateFormat);
    }

    public convertPrimoDateStringToLongDateType(dateString){
        return this.convertDateStringToDateType(dateString, this._primoLongDateFormat);
    }

    public convert24HourStringToDisplayString(timeString:string, delimiter:string=':' ):string{
        return this.fromString(timeString, 'HHmm', 'HH'+delimiter+'mm');
    }

    public convertDateStringToDate(dateString,format) {
        let m = dayjs(dateString, format.toUpperCase(), true);
        return m.isValid() ? m.toDate() : new Date(NaN);
    }

    public convertDateANDTimeTypeToIlsDate(dateObject){
        dateObject.date.setHours(dateObject.hour);
        dateObject.date.setMinutes(dateObject.minute);
         return dateObject.date;
    }

    public convertBookingRequestDateANDTimeTypeToIlsDate(dateObject){
        if(!dateObject.date){
            dateObject = {date : dateObject, hour : '00', minute : '00'}
        }
        dateObject.date.setHours(dateObject.hour ? dateObject.hour : "00");
        dateObject.date.setMinutes(dateObject.minute ? dateObject.minute : "00");
         return dateObject.date;
    }

}




// WEBPACK FOOTER //
// ./src/main/webapp/components/nddUtils/dateUtils.service.ts